import { ReactNode } from 'react';
import clsx from 'clsx';

interface HeaderProps {
  children?: ReactNode;
  icon?: ReactNode;
  isMobile: boolean;
  title?: string;
}

export const Header = ({ children, icon, isMobile, title }: HeaderProps) => {
  if (!icon && !title) return null;

  const renderIcon = () => {
    if (!icon || isMobile) return null;

    return (
      <div className="flex items-center justify-center rounded-full min-w-12 min-h-12 w-12 h-12 bg-primary">
        {icon}
      </div>
    );
  };

  const renderTitle = () => {
    if (children) return children;
    if (!title) return null;

    return (
      <h1
        className={clsx(
          'max-w-fit w-full pr-6 overflow-hidden text-ellipsis whitespace-nowrap',
          {
            'text-2xl': isMobile,
            'text-4xl': !isMobile,
          }
        )}
      >
        {title}
      </h1>
    );
  };

  if (!icon && !title) return null;
  return (
    <div className="inline-flex gap-5 rounded-t items-center p-5 w-full h-20 text-white bg-background-dark border-b-2 border-solid border-b-primary">
      {renderIcon()}
      {renderTitle()}
    </div>
  );
};
